import { render } from "./FilterProduct.vue?vue&type=template&id=ed9ba408"
import script from "./FilterProduct.vue?vue&type=script&lang=js"
export * from "./FilterProduct.vue?vue&type=script&lang=js"
script.render = render

export default script